export default __webpack_public_path__ + "static/media/icon-notification-success.bbb7f31a.svg";